module.exports = __webpack_public_path__ + "img/3.20f18f5c.png";